module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_bacteria_info_scene.c287e5aa.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_bacteria_info_scene.json
// module id = 2228
// module chunks = 0